module.exports = __webpack_public_path__ + "assets/imgs/logos/badoo.9e7d253435bbe912bc300ac6831b26ec.svg";